import React, { useState } from 'react';
import { Modal, Button } from 'antd';

interface ErrorModalProps {
    title?: string;
    message: string;
    visible?: boolean;
    onOk?: ((e: React.MouseEvent<HTMLButtonElement>) => void)
    onCancel?: ((e: React.MouseEvent<HTMLButtonElement>) => void)
}

export const ErrorModal: React.FC<ErrorModalProps> = (props: ErrorModalProps) => {
    const [errorModalVisible, setErrorModalVisible] = useState(props.visible ?? true);
    const handleErrorModalClose = (e: React.MouseEvent<HTMLButtonElement>) => {
        setErrorModalVisible(false);
        if (props.onOk) {
            props.onOk(e)
        }
    };

    const handleErrorModalCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
        setErrorModalVisible(false);
        if (props.onCancel) {
            props.onCancel(e)
        }
    };


    return (
        <Modal
            okType='danger'
            title={props.title ?? "Error"}
            open={errorModalVisible}
            onOk={handleErrorModalClose}
            onCancel={handleErrorModalCancel}
            // footer={[
            //     <Button key="ok" type="primary" onClick={props.onOk}>
            //         OK
            //     </Button>
            // ]}
        >
            <p>{props.message}</p>
        </Modal>
    );
}

export const showErrorModal = ( message: string, title?: string) => {
    return Modal.error({
        title: title,
        content: message
    })
  
}